import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAccountInfo } from 'shared/lib/reducers/cms-account.reducer';
/** Loads `users/api/account` once into Redux `cmsAccount` for approver id & display name. */
export const CmsAccountBootstrap = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAccountInfo());
    }, [dispatch]);
    return null;
};
